<template>
  <div class="portlet">
    <div class="portlet-head">
      <h3><i class="fas fa-hard-hat"></i> Lista podwykonawców</h3>
      <div v-if="isNotSubcontractor">
        <b-button
          variant="outline-primary"
          @click="showModal(null, 'subcontractorprofile-modal')"
        >
          <i class="fas fa-plus"></i> Dodaj Podwykonawcę
        </b-button>
      </div>
    </div>
    <div class="portlet-body">
      <div class="section searchpanel">
        <form @submit.prevent="doSearch">
          <div class="searching searchpanel-item">
            <div class="input-group flex-nowrap">
              <div class="searching-wrapper searchpanel-item">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Szukaj"
                  aria-label="Szukaj"
                  v-model="search"
                />
                <span class="searching-icon">
                  <i class="fas fa-search"></i>
                </span>
                <span
                  class="searching-clean"
                  v-show="search"
                  @click="cleanSearch"
                >
                  <i class="fas fa-times"></i>
                </span>
              </div>
              <div class="input-group-append">
                <button
                  class="btn btn-sm btn-outline-secondary d-none"
                  type="submit"
                >
                  Szukaj
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <b-table
        class="table table-list table-mobilepro"
        ref="subcontractors_table"
        :fields="fields"
        :busy.sync="isBusy"
        :items="getSubcontractors"
        stacked="lg"
      >
        <template v-slot:head(email)>Dane kontaktowe</template>
        <template v-slot:head(insurance)="data">{{ data.label }}</template>
        <template v-slot:head(exemption_certificate)="data">{{
          data.label
        }}</template>
        <template v-slot:head(self_employment)="data">{{
          data.label
        }}</template>
        <template v-slot:head(options)="data">{{ data.label }}</template>

        <template v-slot:table-busy>
          <TableSpiner />
        </template>
        <template v-slot:cell(email)="data">
          {{ data.item.firstname }} {{ data.item.lastname }}
          <br />
          <div class="text-break">{{ data.item.email }}</div>
        </template>
        <template v-slot:cell(positions)="data">
          <ul class="m-0 pl-3">
            <li v-for="(item, index) in data.item.positions" :key="index">
              <span class="badge badge-info">{{ changePositionName(item) }}</span>
            </li>
          </ul>
        </template>
        <template v-slot:cell(insurance)="data">
          <div v-if="data.item.insurance == '1'">
            {{ data.item.insurance_valid_to | date }}
            <br />
            <label
              v-if="isUptoDate(data.item.insurance_valid_to)"
              class="badge badge-danger"
              >Nie aktualne</label
            >
          </div>
          <div class="badge badge-secondary" v-else>Brak</div>
        </template>
        <template v-slot:cell(exemption_certificate)="data">
          <div v-if="data.item.exemption_certificate == '1'">
            {{
              data.item.exemption_certificate_valid_to | date
            }}
            <br />
            <label
              v-if="isUptoDate(data.item.exemption_certificate_valid_to)"
              class="badge badge-danger"
              >Nie aktualne</label
            >
          </div>
          <div class="badge badge-secondary" v-else>Brak</div>
        </template>
        <template v-slot:cell(self_employment)="data">
          <label
            class="badge badge-success"
            v-if="data.item.self_employment == '1'"
            >Tak</label
          >
          <label class="badge badge-secondary" v-else>Nie</label>
        </template>
        <template v-slot:cell(status)="data">
          <span :class="classBadge(data.value)">{{ data.value }}</span>
        </template>
        <template v-slot:cell(created_at)="data">{{
          data.item.created_at | date
        }}</template>
        <template v-slot:cell(options)="data">
          <b-dropdown no-caret right variant="light" class="btn-rounded">
            <template v-slot:button-content>
              <i class="fas fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item-button
              @click="showModal(data.item.id, 'subcontractorprofile-modal')"
              >Edytuj profil</b-dropdown-item-button
            >
            <b-dropdown-item-button
              @click="showModal(data.item.id, 'changeemail-modal')"
              >Zmień e-mail</b-dropdown-item-button
            >
            <b-dropdown-item-button
              @click="showModal(data.item.id, 'changepassword-modal')"
              >Zmień hasło</b-dropdown-item-button
            >
            <b-dropdown-item-button
              @click="changeStatus(data.item.status, data.item.id)"
            >
              <span v-if="data.item.status === 'disabled'" class="text-success"
                >Aktywuj konto</span
              >
              <span v-if="data.item.status === 'active'" class="text-info"
                >Deaktywuj konto</span
              >
            </b-dropdown-item-button>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button
              class="danger"
              @click="remove(data.item.id)"
            >
              <i class="fas fa-trash-alt"></i> Usuń
            </b-dropdown-item-button>
          </b-dropdown>
        </template>
      </b-table>
    </div>
    <ModalUserChangeEmail
      :user="selected"
      :onClose="this.handleDeselect"
      :prefix="this.prefix"
    />
    <ModalUserChangePassword
      :user="selected"
      :onClose="this.handleDeselect"
      :prefix="this.prefix"
    />
    <ModalSubcontractorProfile
      :user="selected"
      v-on:onClose="this.handleDeselect"
      v-on:onSubmit="this.handleAppendItem"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
/* Services */
import SubcontractorsService from "@/services/subcontractors.service";
import userManager from "@/services/userManager.service";
/* depedencies components */
import TableSpiner from "../components/TableSpiner";
import ModalUserChangeEmail from "../components/userManager/ModalUserChangeEmail";
import ModalUserChangePassword from "../components/userManager/ModalUserChangePassword";
import ModalSubcontractorProfile from "../components/ModalSubcontractorProfile";
import {changePositionName} from "@/utils/index";
import dayjs from "dayjs";
import {formatDateOnly} from "@/services/helpers";


export default {
  name: "TheSubcontractors",
  components: {
    TableSpiner,
    ModalUserChangeEmail,
    ModalUserChangePassword,
    ModalSubcontractorProfile,
  },
  computed: {
    ...mapGetters("user", ["isNotSubcontractor"]),
    prefix() {
      return "subcontractor";
    },
  },
  data() {
    return {
      readonly: true,
      search: "",
      isBusy: false,
      selected: {},
      items: null,
      nowDateTime: null,
      fields: [
        "email",
        { key: "phone", label: "Telefon" },
        {
          key: "positions",
          label: "Stanowiska",
        },
        { key: "insurance", label: "Ubezpieczenia do", class: "text-right" },
        {
          key: "exemption_certificate",
          label: "Zwolnienie z podatku do",
          class: "text-right",
        },
        {
          key: "self_employment",
          label: "Samozatrudnienie",
          class: "text-center",
        },
        { key: "created_at", label: "Utworzono" },
        { key: "status", label: "Status" },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
    };
  },
  created(){
      if(this.isNotSubcontractor === false){
        this.$router.push("/");
      }


  },
  mounted() {
    this.nowDateTime = dayjs();
    if (this.isNotSubcontractor === false) {
       this.fields.splice(6, 3);
    }
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  methods: {
    changePositionName,

    cleanSearch() {
      this.search = "";
      this.doSearch();
    },
    doSearch() {
      this.items = null;
      this.$refs.subcontractors_table.refresh();
      return false;
    },
    getSubcontractors() {
      if (this.$_.isNull(this.items) === false) {
        return this.items;
      }
      this.$Progress.start();
      return SubcontractorsService.search(this.search.trim())
        .then((items) => {
          this.items = items;
          return this.items;
        })
        .catch(() => {
          return [];
        });
    },
    changeStatus(currentStatus, userId) {
      let newStatus = currentStatus === "disabled" ? "active" : "disabled";
      this.$Progress.start();
      userManager.changeStatus(userId, newStatus, this.prefix).then(() => {
        let user = this.$_.find(this.items, { id: userId });
        user.status = newStatus;
      });
    },
    remove(userId) {
      this.$bvModal
        .msgBoxConfirm("Do you really want to delete this employee?", {
          title: "Confirm delete employee",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
        })
        .then((result) => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          SubcontractorsService.delete(userId).then(() => {
            let index = this.$refs.subcontractors_table.localItems.findIndex(
              (user) => user.id === userId
            );
            if (~index)
              this.$refs.subcontractors_table.localItems.splice(index, 1);
          });
        });
    },
    showModal(userId, modalid) {
      if (userId) {
        this.selected = this.$_.find(this.items, { id: userId });
      }
      this.$nextTick(() => {
        this.$bvModal.show(modalid);
      });
    },
    handleDeselect: function () {
      this.selected = {};
    },
    handleAppendItem: function (newUser) {
      this.items.unshift(newUser);
      this.$refs.subcontractors_table.localItems.unshift(newUser);
    },
    classBadge(v) {
      return userManager.classBadge(v);
    },
    isUptoDate(toDate) {
      return "isAfter", dayjs(this.nowDateTime).isAfter(toDate);
    },

  },
};
</script>
